<template>
    <b-modal id="add-badge-icon-modal" title="Add badge icon" body-bg-variant="white" body-class="bg-white"
             v-model="showAddBadgeIcon" >
<!--        <div v-for="badgeIcon in availableBadgeIcons">-->
<!--            <input type="radio" id="one" :value="badgeIcon.downloadUrl" v-model="picked">-->
<!--            <img style="max-width:100px" :src="badgeIcon.downloadUrl"/>-->
<!--        </div>-->
        <div class="container-grid pl-3">
            <div class="col-grid" v-for="column in columns">
                <div class="item-container" v-for="badgeIcon in column">
                    <input type="radio" id="one" :value="badgeIcon" v-model="picked">
                    <img style="max-width:100px" :src="badgeIcon.downloadUrl"/>
                </div>
            </div>
        </div>
        <template v-slot:modal-footer>
            <b-button variant="secondary" @click="showAddBadgeIcon = false">Close</b-button>
            <b-button variant="primary"  @click="()=>{pickIcon(picked);showAddBadgeIcon = false}"
                      v-bind:disabled="picked == null">Save</b-button>
        </template>
    </b-modal>
</template>

<script>
  import {mapActions, mapState} from "vuex";
  import {firestore, } from "../../main";
  import Vue from "vue";
  import vSelect from "vue-select";

  export default {
    name: "AddBadgeIcon",
    components: {vSelect},
    data(){
      return {
        showAddBadgeIcon: false,
        popover: false,
        error: null,
        picked: null,
        cols: 2
      }
    },
    computed: {
      ...mapState("badges", ["availableBadgeIcons"]),
      columns: function() {
        let columns = []
        if(this.availableBadgeIcons) {
            let mid = Math.ceil(this.availableBadgeIcons.length / this.cols)
            for (let col = 0; col < this.cols; col++) {
                columns.push(this.availableBadgeIcons.slice(col * mid, col * mid + mid))
            }
        }
        return columns
      }
    },
    methods: {
      ...mapActions("badges", ["getAvailableBadgeIcons", "pickIcon"]),
    },
    async mounted() {
      await this.getAvailableBadgeIcons();
    }
  }
</script>

<style scoped>
    .container-grid {
        display: flex;
    }
    .col-grid {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
    }
</style>
